import { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Toolbar from "@material-ui/core/Toolbar";
import SupportButton from "../input/SupportButton";
import HelpButton from "../input/HelpButton";
import ProfileButton from "../input/ProfileButton";
import NotificationButton from "../input/NotificationButton";
import MessageButton from "../input/MessageButton";

import { makeStyles } from "@material-ui/core/styles";


import "./TopPaneLayout.css";
import OptionListLoader from "../functional/OptionListLoader";

const lightColor = "rgba(255, 255, 255, 0.7)";

const useStyles = makeStyles((theme) => ({
    primaryBar: {
        paddingLeft: 0
    },
    secondaryBar: {
        zIndex: 0,
    },
    menuButton: {
        marginLeft: -theme.spacing(1),
    },
    iconButtonAvatar: {
        padding: 4,
    },
    link: {
        textDecoration: "none",
        color: lightColor,
        "&:hover": {
            color: theme.palette.common.white,
        },
    },
    button: {
        borderColor: lightColor,
    },
}));

function TopPaneLayout(props) {

    const classes = useStyles();

    const { children } = props;

    const [ useMessage, setUseMessage ] = useState(false);

    const onApprovalOptionLoaded = ( optionMap ) => {
        
        if ( optionMap && optionMap["useMessage"] ) {

            if ( optionMap["useMessage"].toLowerCase() === "true" ) {

                setUseMessage ( true );
    
            } else {
    
                setUseMessage ( false );
    
            }
    
        } else {

            setUseMessage ( true );

        }

    }

    return (
        <>
            <OptionListLoader optionPath="approval" onLoaded={onApprovalOptionLoaded} />
            <AppBar color="primary" position="fixed" elevation={0}>
                <Toolbar className={classes.primaryBar} style={{marginLeft: "179px", height: "48px"}}>
                    <Grid container nowrap spacing={1} alignItems="center">
                        <Grid item xs>
                            {children}
                        </Grid>
                        <Grid item>
                            <span></span>
                        </Grid>
                        <Hidden mdDown>
                            <Grid item>
                                <SupportButton />
                            </Grid>
                            <Grid item>
                                <HelpButton />
                            </Grid>
                            <Grid item>
                            {
                                useMessage
                                ?
                                <MessageButton />
                                :
                                <NotificationButton /> 
                            }
                            </Grid>
                            <Grid item>
                                <ProfileButton />
                            </Grid>
                        </Hidden>
                    </Grid>
                </Toolbar>
            </AppBar>
        </>
    );

}

export default TopPaneLayout;

